import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select, { components } from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import TableControl from 'pages/parts/TableControl'

import { PGET, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDateBackend, findFromArrayById, formatDate } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"
import { useNavigate } from "react-router-dom"

function Index() {
	const { t } = useTranslation()

	const reduxSettings = useSelector(state => state.settings)
	const reduxAccount = useSelector(state => state.account)

	const url = 'report-balance-product-new'
	const totalUrl = 'report-balance-total-new'

	const seasons = [{ id: 0, name: t('EMPTY') }, { id: 1, name: t('SEASONAL') }, { id: 2, name: t('NOT_SEASONAL') }]
	const currencies = [{ id: 1, name: "So`m" }, { id: 2, name: "USD" }]

	const [categoriesInitial, setCategoriesInitial] = useState([])
	const [poses, setPoses] = useState([])
	const [organizations, setOrganizations] = useState([])
	const [categories, setCategories] = useState([])
	const [totalAmount, setTotalAmont] = useState(0)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [uomModal, setUomModal] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [modalTableControl, setModalTableControl] = useState(false)
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [pageCount, setPageCount] = useState(0)

	// helper to format time as HH:mm
	const formatTime = (d) => {
		if (!d) return null
		const hh = d.getHours().toString().padStart(2, '0')
		const mm = d.getMinutes().toString().padStart(2, '0')
		return `${hh}:${mm}`
	}

	const initialCurrencyId = reduxSettings?.currencyId ? reduxSettings.currencyId : 1

	const today = new Date()
	const defaultDateBalance = formatDateBackend(today)

	const [filterData, setFilterData] = useState({
		posId: reduxAccount.posId,
		dateBalance: null, //defaultDateBalance,
		timeAt: null,             // single time point (HH:mm)
		productCategoryId: null,
		organizationId: null,
		currencyId: initialCurrencyId,
		seasonal: undefined,
		search: '',
		page: 0,
		random: 0,
		tableSortKey: undefined,
		tableSortDirection: undefined,
	})

	const [pagination, setPagination] = useState({
		url: `/services/web/api/${url}/` + initialCurrencyId,
		response: null
	})

	const [data, setData] = useState([])
	const [URL, setURL] = useState(`/services/web/api/${url}/` + initialCurrencyId)
	const navigate = useNavigate();

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		let filterUrl = `/services/web/api/${url}/` + filterData.currencyId
		let urlParams = ""
		checkFilter()

		if (filterData.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.organizationId)
			urlParams += returnSign(urlParams) + 'organizationId=' + filterData.organizationId
		if (filterData.productCategoryId)
			urlParams += returnSign(urlParams) + 'productCategoryId=' + filterData.productCategoryId
		if (filterData?.seasonal)
			urlParams += returnSign(urlParams) + 'seasonal=' + filterData?.seasonal
		if (filterData.dateBalance) {
			urlParams += returnSign(urlParams) + 'dateBalance=' + filterData.dateBalance
		}
		else {
			//urlParams += returnSign(urlParams) + 'dateBalance=' + defaultDateBalance
		}
		if (filterData.timeAt)
			urlParams += returnSign(urlParams) + 'timeAt=' + filterData.timeAt
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if (`/services/web/api/${url}/` + filterData.currencyId + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		if (tableSort) {
			const fd = { ...filterData }
			if (fd.tableSortKey === tableSort) {
				fd.tableSortDirection = (fd.tableSortDirection === ',asc') ? ',desc' : ',asc'
			} else {
				fd.tableSortDirection = ',asc'
			}
			fd.tableSortKey = tableSort
			fd.page = 0
			setFilterData(fd)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + fd.tableSortDirection
		}

		const withoutParams = filterUrl
		filterUrl = filterUrl + urlParams

		setURL(filterUrl)

		if (exportToExcel) {
			const excelUrl = `/services/web/api/${url}-excel/` + filterData.currencyId + urlParams + returnSign(filterUrl)
			const excelHeaders = [[t('POS'), t('PRODUCT_ID'), t('NAME_OF_PRODUCT'), t('BARCODE'), t('ARTIKUL'), t('CATEGORY'), t('QUANTITY'), t('UNIT'), t('TOTAL_AMOUNT')]]
			const response = await GET(excelUrl)
			for (let i = 0; i < response.length; i++) {
				const row = []
				row.push(response[i].posName)
				row.push(response[i].productId)
				row.push(response[i].productName)
				row.push(response[i].productBarcode)
				row.push(response[i].productArtikul)
				row.push(response[i].categoryName)
				row.push(response[i].balance)
				row.push(response[i].uomName)
				row.push(response[i].totalAmount)
				excelHeaders.push(row)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('BALANCE_REPORT') + ".xlsx");
		} else {
			const response = await PGET(withoutParams, { ...filterData, page: 0, size: ItemsPerPage }, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, url: filterUrl, response })
				setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
				setFilterData(fd => ({ ...fd, page: 0 }))
			}

			const totalReqUrl = `/services/web/api/${totalUrl}/` + filterData.currencyId + urlParams
			const temporaryTotalAmount = await GET(totalReqUrl)
			setTotalAmont(temporaryTotalAmount)
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		const baseUrl = `/services/web/api/${url}/1`
		setFilterData({
			posId: null,
			dateBalance: null, //defaultDateBalance,
			timeAt: null,
			productCategoryId: null,
			organizationId: null,
			currencyId: 1,
			seasonal: undefined,
			search: '',
			page: 0,
			random: 0,
			tableSortKey: undefined,
			tableSortDirection: undefined,
		})
		setFilterDataExist(false)
		setURL(baseUrl)
		setPagination(p => ({ ...p, url: baseUrl, response: null }))
		// No auto-fetch on reset (will fetch on APPLY)
	}

	async function getData(targetUrl = URL) {
		const response = await PGET(targetUrl, { ...filterData, size: ItemsPerPage }, { loader: true })
		if (response) {
			setPagination({ ...pagination, url: targetUrl, response })
			setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
			setData(response.data)
		}

		let totalParams = ""
		if (filterData.posId)
			totalParams += returnSign(totalParams) + 'posId=' + filterData.posId
		if (filterData.organizationId)
			totalParams += returnSign(totalParams) + 'organizationId=' + filterData.organizationId
		if (filterData.productCategoryId)
			totalParams += returnSign(totalParams) + 'productCategoryId=' + filterData.productCategoryId
		if (filterData?.seasonal)
			totalParams += returnSign(totalParams) + 'seasonal=' + filterData?.seasonal
		if (filterData.dateBalance)
			totalParams += returnSign(totalParams) + 'dateBalance=' + filterData.dateBalance
		if (filterData.timeAt)
			totalParams += returnSign(totalParams) + 'timeAt=' + filterData.timeAt
		if (filterData.search)
			totalParams += returnSign(totalParams) + 'search=' + filterData.search

		const response2 = await GET(`/services/web/api/${totalUrl}/` + filterData.currencyId + totalParams, {}, { loader: false })
		if (response2) {
			setTotalAmont(response2)
		}
	}

	function checkFilter() {
		if (
			filterData.posId === null &&
			filterData.dateBalance === null &&
			filterData.timeAt === null &&
			filterData.currencyId === 1 &&
			filterData.search === '' &&
			!filterData.organizationId &&
			!filterData.productCategoryId &&
			!filterData.seasonal
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			response.unshift({ id: null, name: t('ALL') })
			setPoses(response)
		}
	}

	async function getOrganizations() {
		const response = await GET('/services/web/api/organization-balance-helper')
		if (response) {
			setOrganizations(response)
		}
	}

	async function getCategories() {
		const response = await GET('/services/web/api/product-category-helper')
		const arr = []
		for (let i = 0; i < response.length; i++) {
			response[i]['label'] = ' ' + response[i]['name']
			response[i].child = false;
			if (response[i].parentId !== 0) {
				const index = response.findIndex(x => x.id === response[i].parentId)
				if (index !== -1) {
					response[i].child = true;
					if (response[index].options && response[index].options.length > 0) {
						response[index].options.push(response[i])
					} else {
						response[index].options = [response[i]]
					}
				} else {
					arr.push(response[i])
				}
			} else {
				arr.push(response[i])
			}
		}
		setCategories(arr)
		setCategoriesInitial(response)
	}

	async function paginate(p) {
		const selected = p.selected
		const response = await PGET(URL, { ...filterData, page: selected, size: ItemsPerPage }, { loader: true })
		setFilterData(fd => ({ ...fd, page: selected }))
		setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		setData(response.data);
	}

	// Load helpers + categories when ItemsPerPage changes (safe)
	useEffect(() => {
		getPoses()
		getOrganizations()
		getCategories()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	// Initial data load (on mount)
	useEffect(() => {
		getData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// Only search on explicit deps: search text or ItemsPerPage change
	useEffect(() => {
		searchWithFilter(false)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterData.search, ItemsPerPage])

	const GroupHead = props => {
		return (
			<div
				style={{
					padding: '0',
					color: filterData.productCategoryId === props.data.id ? '#fff' : '#999',
					fontWeight: 'bold',
					backgroundColor: filterData.productCategoryId === props.data.id ? '#2684FF' : '#fff',
					fontSize: '.8rem'
				}}
				onClick={() => selectCategory(props.data)}
			>
				<components.Option {...props} />
			</div>
		);
	};

	const Option = props => {
		return (
			<div
				style={{
					padding: props.data.child ? '0 0 0 20px' : '0',
					color: '#999',
					fontWeight: props.data.parentId === 0 ? 'bold' : 'normal',
					fontSize: '.8rem'
				}}
			>
				<components.Option {...props} />
			</div>
		);
	};

	async function selectCategory(option) {
		setIsOpen(!isOpen)
		if (option === null) {
			setFilterData({ ...filterData, productCategoryId: null, page: 0 })
		} else {
			setFilterData({ ...filterData, productCategoryId: option.id, page: 0 })
		}
	}

	function Details(item) {
		navigate(`/report/balance-details/${item.productId}`, { state: { productName: item.productName } })
	}



	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">{t('BALANCE_REPORT')}</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}
									disableGroupSearch
								/>
							</div>

							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(o => o.id === filterData.posId) || ''}
													onChange={(o) => setFilterData({ ...filterData, posId: o.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CURRENCY')}</label>
												<Select
													options={currencies}
													value={currencies.find(o => o.id === filterData.currencyId)}
													onChange={(o) => setFilterData({ ...filterData, currencyId: o.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('SUPPLIER')}</label>
												<Select
													options={organizations}
													value={organizations.find(o => o.id === filterData.organizationId) || ''}
													onChange={(o) => setFilterData({ ...filterData, organizationId: o.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CATEGORY')}</label>
												<Select
													isClearable
													components={{ GroupHeading: GroupHead, Option }}
													classNamePrefix="react-select"
													options={categories}
													value={categoriesInitial.find(o => o.id === filterData.productCategoryId) || ''}
													onChange={(o) => selectCategory(o)}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(o) => o.label}
													getOptionValue={(o) => o.id}
													onMenuOpen={() => setIsOpen(true)}
													onBlur={() => setIsOpen(false)}
													menuIsOpen={isOpen}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('DATE')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.dateBalance ? new Date(filterData.dateBalance) : ''}
														onChange={(date) => setFilterData({ ...filterData, dateBalance: formatDateBackend(date), page: 0 })}
													/>
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											{/* <div className="form-group col-md-6">
												<label>{t('AT_TIME')}</label>
												<div className="calendar-input">
													<DatePicker
														selected={
															filterData.timeAt
																? new Date(`1970-01-01T${filterData.timeAt}:00`)
																: new Date("1970-01-01T23:59:00")
														}
														onChange={(d) => setFilterData({ ...filterData, timeAt: formatTime(d), page: 0 })}
														showTimeSelect
														showTimeSelectOnly
														timeIntervals={5}
														timeCaption="Time"
														dateFormat="HH:mm"
														className="form-control"
													/>
													<i className="uil uil-clock"></i>
												</div>
											</div> */}
											<div className="form-group col-md-6">
												<label>{t('SEASONALITY')}</label>
												<Select
													isClearable
													classNamePrefix="react-select"
													options={seasons}
													value={seasons.find(o => o.id === filterData.seasonal || '')}
													onChange={(o) => setFilterData({ ...filterData, seasonal: o?.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>

							<div>
								<button className="btn btn-outline-primary btn-wide" onClick={() => searchWithFilter(true)}>EXCEL</button>
							</div>
						</div>

						<div className={"vertical-center " + (totalAmount?.uomList?.length > 4 ? 'cursor' : '')} onClick={() => setUomModal(true)}>
							<h4>
								<b>{t('TOTAL_AMOUNT')}</b>: {formatMoney(totalAmount?.totalAmount)}
							</h4>
							<h4 className="d-flex justify-content-between">
								<div><b>{t('QUANTITY')}</b>:</div> {formatMoney(totalAmount?.countProduct)}
							</h4>
							{totalAmount?.uomList?.length < 4 &&
								totalAmount?.uomList?.map((item, index) => (
									<h4 key={index} className="d-flex justify-content-between mt-2">
										<div><b>{t(item.uomName)}</b>:</div>{formatMoney(item.countProduct)}  |  {formatMoney(item.balanceProduct)}
									</h4>
								))
							}
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.organizationId &&
									<span className="me-2">
										<b>{t('SUPPLIER')}: </b> {findFromArrayById(organizations, filterData.organizationId)}
									</span>
								}
								{filterData.productCategoryId &&
									<span className="me-2">
										<b>{t('CATEGORY')}: </b> {findFromArrayById(categoriesInitial, filterData.productCategoryId)}
									</span>
								}
								{filterData.seasonal &&
									<span className="me-2">
										<b>{t('SEASONALITY')}: </b> {findFromArrayById(seasons, filterData.seasonal)}
									</span>
								}
								{filterData.currencyId &&
									<span className="me-2">
										<b>{t('CURRENCY')}: </b> {findFromArrayById(currencies, filterData.currencyId)}
									</span>
								}
								{filterData.dateBalance &&
									<span className="me-2">
										<b>{t('DATE')}: </b>
										<span>{formatDate(filterData.dateBalance)}</span>
									</span>
								}
								{filterData.timeAt &&
									<span className="me-2">
										<b>{t('AT_TIME')}: </b>
										<span>{filterData.timeAt}</span>
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e);
							setFilterData(fd => ({ ...fd, page: 0, random: fd.random + 1 }));
						}}
					/>

					<div className="table-responsive">
						<table className="table table-hover cursor mb-0">
							<thead>
								<tr>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.pos) &&
										<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'posName')}>
											{t('POS')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'productName')}>
										{t('NAME_OF_PRODUCT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.categoryName) &&
										<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'categoryName')}>
											{t('CATEGORY')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'productBarcode')}>
										{t('BARCODE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.artikul) &&
										<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'productArtikul')}>
											{t('ARTIKUL')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'balance')}>
										{t('QUANTITY')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'balance') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'balance') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable text-center cursor table-control" onClick={() => searchWithFilter(false, 'totalAmount')}>
										<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
										{t('TOTAL_AMOUNT')}
										<div className="table-sort me-2">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										{ /*  onClick={Details} */}
										{(!reduxSettings.tableReport || reduxSettings.tableReport?.pos) &&
											<td>{item.rowNum}. {item.posName}</td>
										}
										<td>
											<span
												className="text-primary cursor table-first-column-clickable"
												onClick={() => Details(item)}
											>
												{item.productName}
											</span>
										</td>
										{(!reduxSettings.tableReport || reduxSettings.tableReport?.categoryName) &&
											<td className="text-center">{item.categoryName}</td>
										}
										<td className="text-center">{item.productBarcode}</td>
										{(!reduxSettings.tableReport || reduxSettings.tableReport?.artikul) &&
											<td className="text-center">{item.productArtikul}</td>
										}
										<td className="text-center">{formatMoney(item.balance)} {item.uomName}</td>
										<td className="text-end">{formatMoney(item.totalAmount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} reduxPage={filterData.page} />
				</div>
			</div>

			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableReport'}
			/>
			{/* MODAL TABLE CONTROL */}

			{/* MODAL PAYMENT */}
			<Modal show={uomModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setUomModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('UNIT_OF_MEASUREMENT')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<table className="table">
						<thead>
							<tr>
								<th>{t('UNIT_OF_MEASUREMENT')}</th>
								<th>{t('RESIDUE')}</th>
								<th className="text-end">{t('QUANTITY')}</th>
							</tr>
						</thead>
						<tbody>
							{totalAmount?.uomList?.map((item, index) => (
								<tr key={index}>
									<td>{item.uomName}</td>
									<td>{formatMoney(item.balanceProduct)}</td>
									<td className="text-end">{formatMoney(item.countProduct)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}
		</>
	)
}

export default Index
